import { PerBoxModel } from '../model/per-box-model';
import { PerEmployeeCardsModel } from '../model/per-employee-cards-model';
import { HvlConfigurationService } from '@hvlng/framework-bff/core';

export function sortBoxList(boxesList: PerBoxModel[]) {
    boxesList.sort((a: PerBoxModel, b: PerBoxModel) => a?.pageName?.localeCompare(b?.pageName));
    boxesList.sort((a: PerBoxModel, b: PerBoxModel) => a.displayOrder - b.displayOrder);
}

export function addBox(boxesList: PerBoxModel[], cardCode: string, cardInfoList: PerEmployeeCardsModel[],configurationService:HvlConfigurationService) {

    let cardInfo = cardInfoList?.find(it => it.employeeCard.code == cardCode);
    if (!cardInfo?.cardUsage || !cardInfo.isVisibleToEmployee)
        return;

    if (!cardInfo.editSelf && !cardInfo.viewSelf)
        return;

    let box = new PerBoxModel(cardInfo.employeeCard.detailMap.get( configurationService.config.theme.language.system.code).longText, cardCode, '', 'green', cardInfo.id, cardInfo.iconDisplay ? cardInfo.iconName : null, cardInfo.imageDisplay, cardInfo.imageSrc);
    box.displayOrder = cardInfo.displayOrder;

    boxesList.push(box);
}

